import { render, staticRenderFns } from "./TireWorkshop.vue?vue&type=template&id=9c771c0a&"
import script from "./TireWorkshop.vue?vue&type=script&lang=js&"
export * from "./TireWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./TireWorkshop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports